import React, { createContext, useState, useContext, ReactNode } from 'react'

interface SelectedWeekContextType {
  selectedWeek: string
  setSelectedWeek: (week: string) => void
}

const SelectedWeekContext = createContext<SelectedWeekContextType | undefined>(undefined)

export const useSelectedWeek = (defaultWeek: string | null): SelectedWeekContextType => {
  const context = useContext(SelectedWeekContext)
  if (!context) {
    throw new Error('useSelectedWeek must be used within a SelectedWeekProvider')
  }

  const { selectedWeek, setSelectedWeek } = context

  // Set the initial week if it's not already set
  useState(() => {
    if (selectedWeek === null && defaultWeek !== null) {
      setSelectedWeek(defaultWeek)
    }
  })
  return context
}

interface SelectedWeekProviderProps {
  children: ReactNode
  defaultWeek: string // Optional initial week
}

export const SelectedWeekProvider: React.FC<SelectedWeekProviderProps> = ({
  children,
  defaultWeek = '2025-W40',
}) => {
  const [selectedWeek, setSelectedWeek] = useState<string>('2025-W40')

  const value: SelectedWeekContextType = {
    selectedWeek,
    setSelectedWeek,
  }

  return <SelectedWeekContext.Provider value={value}>{children}</SelectedWeekContext.Provider>
}

export default SelectedWeekContext
